import React from 'react'
import { Icon } from '@iconify/react'

import { Avatar, Button } from '../../atoms'

import { Footer } from '../../molecules'

import { ReactComponent as PepperLogo } from '../../assets/pepper_logo_black.svg'
import { ReactComponent as ArtworkSWW } from '../../assets/sww_artwork.svg'

import styles from './_.module.css'

interface ErrorBoundaryProps {
  user: {
    id: string
    fullName: string
    email: string
    avatar: string
  } | null
  creatorProfile?: boolean
}

export const ErrorBoundary = ({
  user,
  creatorProfile = false
}: ErrorBoundaryProps): JSX.Element => {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <PepperLogo />
        {user?.fullName && (
          <div className={styles.avatarGroup}>
            <Avatar
              className={styles.avatar}
              size="default"
              src={user.avatar}
            />
            <span className={styles.name}>{user.fullName}</span>
          </div>
        )}
      </header>
      <div className={styles.hr} />
      <div className={styles.body}>
        <div className={styles.errImg}>
          <ArtworkSWW />
        </div>
        <div className={styles.title}>Oops, something went wrong...</div>
        <div className={styles.subtitle}>
          Go back and try that again
          <br />
          Or hit <kbd>Ctrl+Shift+R</kbd> to refresh
        </div>
        {creatorProfile ? (
          <Button
            className={styles.button}
            href="https://www.peppercontent.io"
            type="primary"
          >
            Go Home
          </Button>
        ) : (
          <Button
            className={styles.button}
            onClick={() => {
              window.history.back()

              setTimeout(() => {
                window.location.reload()
              }, 300)
            }}
            type="primary"
            icon={<Icon icon="ant-design:arrow-left-outlined" />}
          >
            Go Back
          </Button>
        )}
      </div>
      <footer className={styles.footer}>
        <div className={styles.footerLinks}>
          <a
            href="https://www.peppercontent.io/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy
          </a>
          <a
            href="https://www.peppercontent.io/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms
          </a>
        </div>
        <Footer />
      </footer>
    </div>
  )
}
